// extracted by mini-css-extract-plugin
module.exports = {"feedbackButton":"FeedbackButton_feedbackButton__JC-u3"};